import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'
import InfoView from 'components/InfoView';
import '../styles/root.css'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import validateInput from '../validations/login/ForgetPassword';
import { userResetPasswrd,setZeroMessageRP } from 'actions';
import Alert from '@material-ui/lab/Alert';
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';

const mapStateToProps = ({auth}) => {
    return {
      authUser: auth.authUser,
      token: auth.token,
      ForgetPassMessage: auth.ForgetPassMessage,
      success: auth.success
    }
  };

function mapDispatchToProps(dispatch) {
    return {
        setZeroMessageRP: () => dispatch(setZeroMessageRP()), 
        userResetPasswrd: (PassWordI) => dispatch(userResetPasswrd(PassWordI)), 
    };
}

class Resetpassword extends Component {
    constructor() {
        super();
        this.state = {
          email: '',
          Orgnr: '',
          Message: '',
          ShowMessage: false,
          errors:{},
          isLoading:false
        }
      }
    componentDidMount=()=>{
        this.props.setZeroMessageRP();
        if (this.props.token !== null) {
           this.props.history.push('/');
        }
    }
    
    isValid =()=>{
        const {errors, isValid} = validateInput(this.state);
        if(!isValid){
         this.setState({errors:errors})
       }
       return isValid;
    }
    render() {
        const {email, Orgnr, Message,ShowMessage,errors} = this.state
       
        return (
            <div className="d-flex justify-content-center align-items-center w-100 bg">
                <div className="app-login-container animated slideInUpTiny animation-duration-3">
                    <div className="app-login-main-content">
                        <div className="app-logo-content d-flex align-items-center justify-content-center">
                            <Link className="logo-lg" to="/" title="Notyfile">
                                <img src={require("assets/images/logo.png")} alt="Notyfile" title="Notyfile"/>
                            </Link>
                        </div>
                        <div className="app-login-content">
                            <div className="app-login-header mb-4">
                                <h1>
                                <IntlMessages id="Account.New.Password.Get" />
                                </h1>
                            </div> 
                            <div className="app-login-form">
                                {
                                    isEmpty(this.props.ForgetPassMessage)?
                                    <form> 
                                   <fieldset>
                                  {/*   <TextField
                                    label={"Företags Orgnr."}
                                    fullWidth
                                    onChange={(event) => this.setState({
                                        Orgnr: event.target.value,
                                        errors:[]
                                    })}
                                    defaultValue={Orgnr}
                                    error ={errors.Orgnr?true:false}
                                    helperText= {errors.Orgnr}
                                    margin="normal"
                                    className="mt-1 my-sm-3"
                                    variant="outlined"
                                    />
                                    */}
                                     <TextField
                                     label={<IntlMessages id="E-mail" />}
                                     fullWidth
                                     onChange={(event) => this.setState({
                                         email: event.target.value,
                                         errors:[]
                                    })}
                                    defaultValue={email}
                                    error ={errors.email?true:false}
                                    helperText= {errors.email}
                                    margin="normal"
                                    className="mt-1 my-sm-3"
                                    variant="outlined"
                                    />

                                    <div className="mb-3 d-flex align-items-center justify-content-between">
                                    <Button
                                    onClick={() => {
                                        if(this.isValid()){
                                            this.setState({ errors: {}, isLoading: true });
                                            this.props.userResetPasswrd({email, Orgnr});                        
                                        }
                                    }} variant="contained" color="primary">
                                        <IntlMessages id="Account.New.Password.Send" />
                                    </Button>
                                    <Link to="/signin">
                                        <IntlMessages id="Log.in" />
                                    </Link>
                                    </div>
                                    </fieldset>
                                </form>
                                    :
                                    <>
<Alert severity={
    this.props.ForgetPassMessage.success?"info":"warning"
}>{this.props.ForgetPassMessage.success?this.props.ForgetPassMessage.message:this.props.ForgetPassMessage.error}</Alert>
<div className="mb-3 d-flex align-items-center justify-content-between">
<Link to="/signin"><IntlMessages id="Log.in" /></Link>
</div>
                                    </>
                                }
                                
                            </div>
                        </div>
                    </div>
                    <InfoView/>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(Resetpassword);